// extracted by mini-css-extract-plugin
export default {"infoBox":"infoBox--iinRF","danger":"danger--RksPD","success":"success--bsgQg","closeButton":"closeButton--ileRo"};